import morocco2022 from './morocco-2022.json';
import lanzarote2022 from './lanzarote-2022.json';
import newyork2022 from './newyork-2022.json';
import istanbul2021 from './istanbul-2021.json';

export default {
  ...morocco2022,
  ...lanzarote2022,
  ...newyork2022,
  ...istanbul2021,
};
